import { Spacing } from '@billy/design-system'
import styled from '@emotion/styled'

export const EmptyViewWrapper = styled.div`
  display: flex;
  align-items: center;
  flex-direction: column;
  justify-content: center;
  height: 100%;
`

export const TitleWrapper = styled.div`
  margin-top: ${Spacing.S16};
  margin-bottom: ${Spacing.S16};
`

export const TextWrapper = styled.div`
  max-width: 840px;
`

export const ButtonWrapper = styled.div`
  margin-top: ${Spacing.S24};
`
